import * as React from 'react';
import { Icon } from 'telia-front-react';
import { observer } from 'mobx-react';
import { TranslationsContext } from '@teliaee/telia-translate';
import { Branch } from '../common/ReservationInterfaces';

interface AccessibilityInformationProps {
  branch: Branch;
}

const AccessibilityInformation: React.FC<AccessibilityInformationProps> = ({ branch }) => {
  const translate = React.useContext(TranslationsContext).translate;

  return (
    <div>
      {branch.accessibilityInformation.map((item) => {
        return (
          <span key={item} aria-label={translate(`ariaLabel.${item}`)}>
            <Icon modifiers={translate(`icon.${item}`)} align={'none'} size={'sm'} />
          </span>
        );
      })}
    </div>
  );
};

export default observer(AccessibilityInformation);
